/* KinderSpeech RO - C315 listicle de vara, scroll-reveal.
   Progressive enhancement, nu este critic. Daca nu se incarca, continutul tot
   se vede (fara clasa .ksrev--js, CSS nu ascunde nimic). */
(function () {
  function init() {
    var roots = document.querySelectorAll('.ksrev');
    if (!roots.length) return;

    roots.forEach(function (root) {
      root.classList.add('ksrev--js');
      var items = root.querySelectorAll('[data-reveal]');

      if (!('IntersectionObserver' in window)) {
        for (var i = 0; i < items.length; i++) items[i].classList.add('is-visible');
        return;
      }

      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            io.unobserve(entry.target);
          }
        });
      }, { rootMargin: '0px 0px -10% 0px', threshold: 0.08 });

      items.forEach(function (el) { io.observe(el); });
    });
  }

  if (document.readyState !== 'loading') {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }
})();